document.addEventListener("DOMContentLoaded", function () {
	const triggers = document.querySelectorAll(".klaviyo-popup-trigger");

	triggers.forEach((trigger) => {
		trigger.addEventListener("click", function (event) {
			event.preventDefault();
			const isMobile = window.innerWidth <= 768;
			// const popupId = isMobile ? "QZzGke" : "XqbVbY";

			window._klOnsite = window._klOnsite || [];
			window._klOnsite.push(["openForm", "UD5MEf"]);
		});
	});
});
